import Helpers from "../utils/helpers";

export default class Auth extends Helpers {
  constructor() {
    super();
    this.body = document.querySelector('body');
    this.popupAuth = this.body.querySelector('.popup-auth');

    if (this.popupAuth) {
      this.headerText = this.popupAuth.querySelector('.popup-auth__header-text');
      this.popupLogin = this.popupAuth.querySelector('.popup-login');
      this.popupRegister = this.popupAuth.querySelector('.popup-register');
      this.popupResetPass = this.popupAuth.querySelector('.popup-reset-password');
      this.successRegisterMessage = this.popupAuth.querySelector('.popup-auth__header-success-registration');
      this.errorRegisterMessage = this.popupAuth.querySelector('.popup-auth__header-error-registration');
      this.overlay = this.body.querySelector('.overlay-bg');
      this.formNewPassword = this.body.querySelector('.js-set-new-password');
      this.formNewPassword && this.formNewPassword.addEventListener('submit', this.setNewPassword.bind(this));
      Helpers.registerHandler('click', this.openForms.bind(this), '.js-open-popup-form');
      Helpers.registerHandler('click', this.hideForms.bind(this), '.overlay-bg');
      Helpers.registerHandler('click', this.hideForms.bind(this), '.js-close-popup-auth');
      Helpers.registerHandlerKeydown("keydown", this.hideForms.bind(this), 27, '', false);
      this.popupLogin && this.popupLogin.addEventListener('submit', this.login.bind(this));
      this.maskORCID();
      Helpers.registerHandler('click', this.hideShowPass.bind(this), '.js-show-pass');
      if (this.popupLogin && this.popupRegister && this.popupResetPass) {

        this.popupRegister.addEventListener('submit', this.register.bind(this));
        this.popupResetPass.addEventListener('submit', this.resetPassword.bind(this));

        Helpers.registerHandler('click', this.showForm.bind(this), '.js-toggle-form');


      }

      this.setNewPassIsLoad = false;
      this.stateForm = {
        login: {
          isLoad: false,
          isShow: false,
          html: this.popupLogin,
        },
        register: {
          isLoad: false,
          isShow: false,
          html: this.popupRegister,
        },
        reset: {
          isLoad: false,
          isShow: false,
          html: this.popupResetPass,
        },
      }
    }

    this.registrationConfirm()
  }

  maskORCID() {
    const orcidInputs = document.querySelectorAll('input[id^="orcid-"]');
    orcidInputs.forEach(function (input) {
      input.setAttribute('maxlength', '19');
      input.addEventListener('input', function (e) {
        let value = e.target.value;
        value = value.replace(/[^0-9xX]/g, '');
        value = value.toUpperCase();
        let formattedValue = '';
        for (let i = 0; i < value.length; i++) {
          if (i > 0 && i % 4 === 0) {
            formattedValue += '-';
          }
          formattedValue += value[i];
        }
        e.target.value = formattedValue;
      });
    });
  }

  registrationConfirm() {
    if (!this.popupAuth) return;
    const urlParams = new URLSearchParams(window.location.search);
    const registration = urlParams.get('registration');
    if (registration) {
      this.openForms();
      if (registration === 'confirmed') {
        this.successRegisterMessage && this.successRegisterMessage.classList.add('show');
      } else if (registration === 'error') {
        this.errorRegisterMessage && this.errorRegisterMessage.classList.add('show');
      }
      const url = new URL(window.location.href);
      url.searchParams.delete('registration');
      window.history.replaceState({}, document.title, url);
    }
  }

  hideForms() {
    this.popupAuth.classList.remove('show');
    this.overlay.classList.remove('show');
    this.enableScroll();
  }

  openForms(target) {
    if (!this.popupAuth) return;
    let redirectUrl = target && target.getAttribute('data-redirect-after-login') ? target.getAttribute('data-redirect-after-login') : window.location.href;
    this.setSessionCookie('um_previous_page', redirectUrl, {
      path: '/',
      sameSite: 'Lax',
    });
    this.successRegisterMessage.classList.remove('show');
    this.errorRegisterMessage.classList.remove('show');
    this.popupAuth.classList.add('show');
    this.overlay.classList.add('show');
    this.disableScroll();
  }

  resetDataForm() {
    Object.values(this.stateForm).forEach(form => {
      if (!form || !form.html) return;
      const fields = form.html.querySelectorAll('input');

      fields.forEach(field => {
        switch (field.type) {
          case 'checkbox':
          case 'radio':
            field.checked = false;
            break;

          default:
            field.value = '';
        }

        field.classList.remove('error');
      });
    });

    const isRegisterMess = this.popupRegister.querySelector('.js-success-register-message.show');
    if (isRegisterMess) {
      isRegisterMess.classList.remove('show');
      this.popupRegister.querySelector('.js-form-register').classList.remove('hide');
    }

    const isResetMess = this.popupResetPass.querySelector('.popup-reset-password__success-message.show');
    if (isResetMess) {
      isResetMess.classList.remove('show');
      this.popupResetPass.querySelector('.js-form-reset-pass').classList.remove('hide');
    }
  }

  showForm(el) {
    this.successRegisterMessage.classList.remove('show');
    this.errorRegisterMessage.classList.remove('show');
    const formName = el.getAttribute('data-form-to-show');
    if (formName === 'login') {
      this.headerText.classList.remove('hide');
    } else {
      this.headerText.classList.add('hide');
    }
    this.resetDataForm()
    Object.keys(this.stateForm).forEach(key => {
      const form = this.stateForm[key];
      const isActive = key === formName;

      form.isShow = isActive;
      form.html.classList.toggle('show', isActive);
    });
  }

  hideShowPass(el) {
    const input = el.nextElementSibling;
    if (input) {
      const show = input.type === 'password';
      el.querySelector('.show-eye').classList.toggle('hide', !show);
      el.querySelector('.hide-eye').classList.toggle('hide', show);
      input.type = show ? 'text' : 'password';
    }
  }

  async setNewPassword(form) {
    form.preventDefault();
    if (this.setNewPassIsLoad) return;
    this.setNewPassIsLoad = true;
    let errorsMessage = form.target.querySelector('.js-text-error');
    try {
      if (errorsMessage) {
        errorsMessage.innerHTML = ''
        errorsMessage.classList.remove('show');
      }
      if (!Helpers.validate(form.target)) return;
      const formData = new FormData(form.target);
      const result = await this.ajaxFetchPost({
        action: 'ajax_set_new_password',
        password: formData.get('email-new-pass'),
        key: formData.get('key'),
        login: formData.get('login'),
      });
      if (result.success) {
        this.formNewPassword.querySelector('.js-success-message').classList.add('show');
        form.target.remove();
      } else if (errorsMessage) {
        errorsMessage.innerHTML = result.data.message;
        errorsMessage.classList.add('show');
      }
    } catch (e) {
      console.log(e, 'e')
    } finally {
      this.setNewPassIsLoad = false;
    }
  }

  async resetPassword(form) {
    form.preventDefault();
    if (this.stateForm.reset.isLoad) return;
    this.stateForm.reset.isLoad = true;

    try {
      let errorsMessage = form.target.querySelector('.js-text-error');
      errorsMessage.innerHTML = ''
      errorsMessage && errorsMessage.classList.remove('show');
      if (!Helpers.validate(form.target)) return;
      const formData = new FormData(form.target);
      const result = await this.ajaxFetchPost({
        action: 'ajax_reset_password',
        email: formData.get('email-reset-pass'),
      });

      if (result.success) {
        form.target.classList.add('hide');
        this.popupResetPass.querySelector('.js-success-message').classList.add('show');
      } else {
        errorsMessage.innerHTML = result.data.message;
        errorsMessage.classList.add('show');
      }
    } catch (e) {
      console.log(e, 'e')
    } finally {
      this.stateForm.reset.isLoad = false;
    }

  }

  async register(form) {
    form.preventDefault();
    if (this.stateForm.register.isLoad) return;
    this.stateForm.register.isLoad = true;

    try {
      let errorsMessage = form.target.querySelector('.js-text-error');
      errorsMessage.innerHTML = ''
      errorsMessage && errorsMessage.classList.remove('show');
      if (!Helpers.validate(form.target)) return;

      const formData = new FormData(form.target);
      const result = await this.ajaxFetchPost({
        action: 'ajax_register_user',
        first_name: formData.get('first_name'),
        second_name: formData.get('second_name'),
        email: formData.get('email-register'),
        password: formData.get('password-register'),
      });

      if (result.success) {
        this.popupRegister.querySelector('.js-success-register-message').classList.add('show');
        form.target.classList.add('hide');
      } else {
        errorsMessage.innerHTML = result.data.message;
        errorsMessage.classList.add('show');
      }
    } catch (e) {
      console.log(e, 'e')
    } finally {
      this.stateForm.register.isLoad = false;
    }
  }

  async login(form) {
    form.preventDefault();
    if (this.stateForm.login.isLoad) return;
    this.stateForm.login.isLoad = true;
    try {
      form.target.querySelector('.js-text-error').classList.remove('show');
      if (!Helpers.validate(form.target)) return;
      const formData = new FormData(form.target);
      const result = await this.ajaxFetchPost({
        action: 'ajax_login_user',
        login: formData.get('login'),
        password: formData.get('password'),
      });

      if (result.success) {
        const redirect = this.getCookie('um_previous_page');
        if (redirect) {
          this.deleteCookie('um_previous_page');
          window.location.href = redirect;
        } else {
          window.location.reload();
        }
      } else {
        form.target.querySelector('.input-pass').value = '';
        form.target.querySelector('.input-pass').focus();
        form.target.querySelector('.js-text-error').classList.add('show');
      }
    } catch (e) {
      form.target.querySelector('.input-pass').value = '';
      form.target.querySelector('.input-pass').focus();
      form.target.querySelector('.js-text-error').classList.add('show');
    } finally {
      this.stateForm.login.isLoad = true;
    }
  }
}
